import { LocalDataSource } from 'ng2-smart-table';
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { RadicationsDocumentsDataService } from './shared/radications-documents.data.service';
import { RadicationsDocumentsConfig } from './shared/radications-documents.config';
import { DefaultDocument } from '@app/shared';
import { Subject } from 'rxjs';

@Component({
  selector: 'iw-radications-documents',
  templateUrl: './radications-documents.component.html',
  styleUrls: ['./radications-documents.component.scss'],
  providers: [RadicationsDocumentsDataService]
})
export class RadicationsDocumentsComponent implements OnInit, OnDestroy {
  // entrada de lso documentos seleccionados del control
  @Input() set documents(documents: number[]) {
    this._documents = documents;
    if (this.source.length) {
      this.loadingDocuments();
    }
  }
  // Configuracion de la tabla
  settings = {};
  // Documentos a seleccionar
  source: DefaultDocument[] = [];
  // Contiene los datos de la tabla previamente seteados y listos para renderizar en la tabla
  sourceData: LocalDataSource;
  // Documentos asociados
  private _documents: number[] = [];
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Retorna los documentos asociados del documento
  @Output() documentsAsociations: EventEmitter<Array<any>> = new EventEmitter();

  constructor(
    private rdds: RadicationsDocumentsDataService
  ) { }

  ngOnInit() {
    const docsC = new RadicationsDocumentsConfig();
    this.settings = docsC.settings;
    docsC.accion.subscribe((data: any) => {
      this.actionTable(data);
    });
    this.rdds.getDefaultDocuments().subscribe(data => {
      this.source = data;
      this.loadingDocuments();
    });
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  get documents(): number[] {
    return this._documents;
  }

  /**
   * Carga los documentos y setea la informacion
   *
   * @param {boolean} [refres=true]
   * @memberof RadicationsDocumentsComponent
   */
  private loadingDocuments(refres: boolean = true) {
    this.source.forEach(sourceD => {
      if (this.documents.length) {
        const index = this.documents.indexOf(sourceD.id);
        if (index !== -1) {
          sourceD['associate'] = 'Sí';
        } else {
          sourceD['associate'] = 'No';
        }
      } else {
        sourceD['associate'] = 'No';
      }
      sourceD['funtions'] = 'NoFuntions';
    });
    if (refres) {
      this.sourceData = new LocalDataSource(this.source);
    }
    this.sourceData.refresh();
  }

  /**
   * Controla las acciones de la tabla
   *
   * @private
   * @param {*} data
   * @memberof RadicationsDocumentsComponent
   */
  private actionTable(data: any) {
    switch (data.action) {
      case 'asociar':
        this.documents.push(data.row.id);
        this.documentsAsociations.emit(this.documents);
        this.loadingDocuments(false);
        break;
      case 'eliminar':
        const index = this.documents.indexOf(data.row.id);
        if (index !== -1) {
          this.documents.splice(index, 1);
        }
        this.documentsAsociations.emit(this.documents);
        this.loadingDocuments(false);
        break;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/creation-form/radications-documents/radications-documents.component.ts